module.exports = "/assets/data/527e849dc18359655c48b427f93a564e-BT52.data.json";